import FormFieldLicensePlate from './FormFieldLicensePlate';
export * from './FormFieldLicensePlate';
export * from './styles/license-plate-input.styled';
export default FormFieldLicensePlate;
//# sourceMappingURL=index.js.map